module.exports = __webpack_public_path__ + "static/media/yes-green.127662ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yes-green.svg
// module id = 522
// module chunks = 0